import { RootInitialState } from 'core/common/store/rootReducer';

export const getNatalChartData = (state: RootInitialState) => state.natalChart.natalChartData;
export const getNatalChartSignsInfo = (state: RootInitialState) => state.natalChart.signsInfo;
